<template>
  <app-modal v-model="isDialogOpened"
             size="md"
             :ok-text="$t('common.yes')"
             @cancel="closeDialog"
             @ok="confirmClick"
  >
    <template #title>
      <span v-t="{
              path: 'project.signing-checklist.list.SigningChecklistVoidedToDraftStepDialog.title',
              plural: count,
            }" />
    </template>
    <template #body>
      <span v-t="{
              path: 'project.signing-checklist.list.SigningChecklistVoidedToDraftStepDialog.body',
              plural: count,
            }" />
    </template>
  </app-modal>
</template>

<script>
import { dialogMixin } from '@/mixins/dialogMixin'

export default {
  name: 'SigningChecklistVoidedToDraftStepDialog',
  mixins: [dialogMixin],
  props: {
    count: {
      type: Number,
      required: true,
    },
  },
  methods: {
    confirmClick () {
      this.$emit('confirm')
      this.closeDialog()
    },
  },
}
</script>
